import { ArgumentsCamelCase } from 'yargs'
import { checkIfNewerVersionAvailableAndLog, getCustomComponentLibraryConfig } from '../../util'
import { build, buildAndDeployDevContiniously } from '../../build_components'
import { getCCLClient } from '../../getCCLClient'

export const devCommand = async (argv: ArgumentsCamelCase<{ 'dry-run': boolean, 'skip-updates-check': boolean, header?: string[] }>) => {
  const cccc = getCustomComponentLibraryConfig()
  const { name } = cccc

  if (!name) {
    throw new Error(
      'Missing required name field in custom component library config (package.json -> retoolCustomComponentLibraryConfig.name must be set)',
    )
  }

  if (argv['dry-run']) {
    await build(true)
  } else {
    const client = await getCCLClient(false, argv.header)
    const { data } = await client.customComponentLibrariesGet()
    const existingCollection = data.find((library) => library.name === name)
    if (!existingCollection) {
      throw new Error('Error, library does not exist on the backend. Try running `npx retool-ccl init` again.')
    }
    const libraryUuid: string = existingCollection.id
    await buildAndDeployDevContiniously(libraryUuid, client)
  }

  await checkIfNewerVersionAvailableAndLog(argv['skip-updates-check'])
}
